/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import Stack from "@mui/material/Stack";

import QuestionVoteitem from "../questionVoteItem";
import "./styles.css";

type TProps = {
  callback: (item: any, value: boolean) => void;
};

function QuestionItem({ question, questionVoting, callback }: TProps) {
  const { author, message, message_edit, vote_count, voted, isAnswered, id } =
    question;
  const questionOwner = question.authorOwner ?? false;
  const authorName =
    author === "Anonymous" || author === undefined
      ? I18n.t("questions.anonymous")
      : author;

  const cleanMessage = DOMPurify.sanitize(message_edit || message, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });

  return (
    <li>
      <Stack
        component="article"
        aria-labelledby={`question-${id}`}
        direction="row"
        justifyContent="space-between"
        className="list-group-item"
      >
        <Stack>
          <h3
            className="question-item-author"
            aria-label={`${I18n.t("questions.author")} ${authorName}`}
          >
            {authorName}
          </h3>
          <p
            id={`question-${id}`}
            // dangerouslySetInnerHTML might not be necessary anymore SSY-3483
            dangerouslySetInnerHTML={{
              __html: cleanMessage,
            }}
          />
        </Stack>
        {questionVoting && (
          <QuestionVoteitem
            voteCount={vote_count}
            initLiked={voted}
            answered={isAnswered}
            disabled={questionOwner}
            toggleLike={(val) => {
              callback(question, val);
            }}
          />
        )}
      </Stack>
    </li>
  );
}

export default QuestionItem;

QuestionItem.propTypes = {
  question: PropTypes.object,
  voted: PropTypes.bool,
  callback: PropTypes.func,
  author: PropTypes.string,
  message: PropTypes.string,
  vote_count: PropTypes.number,
  isAnswered: PropTypes.bool,
  questionVoting: PropTypes.bool,
};
